import React from "react";
import { useSelector } from "react-redux";
import { Button, Col, Row, Container } from "react-bootstrap";
import MeTicketIcon from "./svg/MeTicketIcon";
import styled from "styled-components";
import MeTicketImg from "./img/MeTicketImg.png";
import MeTicketImgMob from "./img/MeTicketImg-m.webp";
import MeTicketImgTab from "./img/MeTicketImg-t.webp";

import background from "./img/background-2.webp";
import backgroundMobile from "./img/background-m.webp";
import backgroundTablet from "./img/background-t.webp";

export default function MeTicketBlockNew() {
  const { lang } = useSelector((state) => ({
    lang: state.changeLang.language.meTicket
  }));

  return (

    <BackgroundDiv>
      <Col xs={10} md={12} className="mx-auto h-100 px-lg-5 ps-md-5">
        <Row className="justify-content-between h-100">
          <Col
            xs={12}
            md={6}
            lg={12}
            className="pt-5 pb-md-5 pb-lg-0 text-center"
          >
            <div className="d-flex justify-content-between flex-column h-100 text-md-start ps-lg-3 card-header" style={{minHeight:"330px"}}>
              <div className="">
                <MeTicketIcon />
                <h2 className="fs-2 lh-sm mb-3 mt-md-5 mt-lg-4 mt-3 col-xl-10">
                  {lang[0]}
                </h2>
                <Col xs={12} lg={12} md={12}>
                  <p className="text-gray mb-0">{lang[1]}</p>
                </Col>
              </div>
              <Row className="g-md-2 g-3 mt-md-0  mt-3">
                <Col xs={12} lg={5} md={10} className="mt-0 mt-md-2">
                  <Button
                    variant="green"
                    className="w-100 fw-bold py-md-3 py-2 text-white d-flex align-items-center justify-content-center"
                    href="https://me-ticket.com/for-organizers/login?utm_source=me-qr&utm_medium=banner&utm_campaign=me-qr-generator-event"
                    target="_blank"
                  >
                    {lang[2]}
                  </Button>
                </Col>
                <Col xs={12} lg={6} md={10} className="d-flex align-items-center justify-content-center">
                  <Button
                    variant="link"
                    className="w-100 py-md-3 py-2 text-green btn btn-link"
                    href="https://me-ticket.com/for-organizers?utm_source=me-qr&utm_medium=banner&utm_campaign=me-qr-generator-code"
                    target="_blank"
                  >
                    {lang[3]}
                  </Button>
                </Col>
              </Row>
            </div>

          </Col>
          <Col md={5} lg={12} className="mt-lg-5">
            <div className="py-md-5 py-lg-0 text-lg-center">
              <picture>
                <source srcSet={MeTicketImgMob} media="(max-width: 500px)" />
                <source srcSet={MeTicketImgTab} media="(max-width: 900px)" />
                <img loading="lazy" className="img-fluid" src={MeTicketImg} width={520}
                     height={306} alt={`meTicket`} />
              </picture>
            </div>
          </Col>
        </Row>
      </Col>
    </BackgroundDiv>

  );
}

const BackgroundDiv = styled.div`
    background-image: url(${background});
    background-size: cover;
    background-repeat: no-repeat;
    border: 1px solid #DDE0E4;
    border-radius: 16px;
    height: 100%;
    @media screen and (max-width: 900px) {
        background-image: url(${backgroundTablet});
    }
    @media screen and (max-width: 430px) {
        background-image: url(${backgroundMobile});
    }
`;
